import { render, staticRenderFns } from "./SettingsNotificationSmtpEmailFrom.vue?vue&type=template&id=1f9152a9&"
import script from "./SettingsNotificationSmtpEmailFrom.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmtpEmailFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports